export enum MppRange {
  START,
  END,
}
